"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUiSchema = void 0;
var tables_1 = require("../../tables/tables");
var Utils_1 = require("../../Utils");
var autoModuleViewHelpers_1 = require("./autoModuleViewHelpers");
function createUiSchema(tab, config, viewModel) {
    var _a;
    var _b, _c, _d;
    var uiSchema = {};
    if (config) {
        if (config.UIOrder) {
            (_c = (0, Utils_1.getKeys)((_b = config.UIOrder) !== null && _b !== void 0 ? _b : {})) === null || _c === void 0 ? void 0 : _c.forEach(function (group) {
                var _a;
                uiSchema[group] = {
                    "ui:order": (_a = config === null || config === void 0 ? void 0 : config.UIOrder) === null || _a === void 0 ? void 0 : _a[group],
                };
            });
        }
        var components = viewModel.viewModel.components;
        var isGroupHidden_1 = {};
        (_d = (0, Utils_1.values)(components !== null && components !== void 0 ? components : {})) === null || _d === void 0 ? void 0 : _d.forEach(function (entry) {
            var _a, _b;
            var _c, _d, _e, _f, _g, _h, _j;
            var component = entry.component;
            var tabIndex = (_d = (_c = component.tabs) === null || _c === void 0 ? void 0 : _c.indexOf(tab)) !== null && _d !== void 0 ? _d : -1;
            if (tabIndex === -1)
                return;
            var isComponentGroupHidden = isGroupHidden_1[component.group] === undefined ||
                isGroupHidden_1[component.group] === true;
            if (isComponentGroupHidden) {
                var isHidden = (_f = ((_e = component.uiBehavior) === null || _e === void 0 ? void 0 : _e["ui:widget"]) === "hidden") !== null && _f !== void 0 ? _f : false;
                if (((_h = (_g = viewModel.getDerivedFunction).isVisible) === null || _h === void 0 ? void 0 : _h.call(_g, component.name)) === false) {
                    isHidden = true;
                }
                isGroupHidden_1[component.group] = isHidden;
            }
            if (component.category === "table") {
                var table = component;
                var tableCols_1 = table.columns;
                var colNames = Object.keys(tableCols_1);
                var defaultAlignment_1 = "left";
                var displayHeadersHorizontally = (_j = table.displayHeadersHorizontally) !== null && _j !== void 0 ? _j : false;
                var displayHeadersDiagonally_1 = !displayHeadersHorizontally;
                var columns_1 = [];
                var defaultColumnWidth_1 = (0, tables_1.calculateColumnWidth)(tableCols_1);
                var headerMaxLength_1 = colNames
                    .map(function (name) { return tableCols_1[name].title.length; })
                    .reduce(function (a, b) { return Math.max(a, b); });
                colNames.forEach(function (name) {
                    var _a, _b, _c, _d, _e, _f;
                    var isColEditable = !tableCols_1[name].readonly;
                    var columnWidth = defaultColumnWidth_1[name];
                    columns_1.push({
                        dataField: name,
                        editable: isColEditable ? undefined : false,
                        columnWidth: tableCols_1[name].columnWidth
                            ? tableCols_1[name].columnWidth + "%"
                            : columnWidth + "%",
                        width: tableCols_1[name].width
                            ? tableCols_1[name].width + "%"
                            : columnWidth + "%",
                        dataSort: tableCols_1[name].isSortable,
                        headerAlign: displayHeadersDiagonally_1
                            ? defaultAlignment_1
                            : (_b = (_a = tableCols_1[name].headerAlign) !== null && _a !== void 0 ? _a : tableCols_1[name].dataAlign) !== null && _b !== void 0 ? _b : defaultAlignment_1,
                        dataAlign: (_d = (_c = tableCols_1[name].dataAlign) !== null && _c !== void 0 ? _c : tableCols_1[name].headerAlign) !== null && _d !== void 0 ? _d : defaultAlignment_1,
                        disabledRows: (_e = tableCols_1[name].disabledRows) !== null && _e !== void 0 ? _e : [],
                        tdStyle: (0, tables_1.getCellStyle)(tableCols_1[name].readonly),
                        headerText: (_f = tableCols_1[name]) === null || _f === void 0 ? void 0 : _f["columnTip"],
                    });
                });
                columns_1 = columns_1.map(function (col) {
                    return __assign(__assign({}, col), { thStyle: (0, tables_1.getHeaderStyle)(headerMaxLength_1, displayHeadersDiagonally_1) });
                });
                uiSchema[table.group] = __assign(__assign({}, uiSchema[table.group]), (_a = {}, _a[table.name] = (0, tables_1.getTableUiSchema)(table, columns_1), _a));
            }
            else {
                uiSchema[component.group] = __assign(__assign({}, uiSchema[component.group]), (_b = {}, _b[component.name] = __assign(__assign({}, getUiBehavior(component, viewModel)), getUiSchemaExportArg(component.name, viewModel)), _b));
            }
        });
        for (var group in isGroupHidden_1) {
            if (isGroupHidden_1[group]) {
                uiSchema[group] = __assign(__assign({}, uiSchema[group]), (_a = {}, _a["ui:widget"] = "hidden", _a));
            }
        }
    }
    return uiSchema;
}
exports.createUiSchema = createUiSchema;
function getUiSchemaExportArg(name, viewModel) {
    var uiSchema = {};
    if (viewModel.isControlledByInterface(name)) {
        var expArg = viewModel.getProcessedArgValue(name);
        if (expArg) {
            uiSchema = {
                "ui:readonly": true,
                "ui:help": "Controlled by " + expArg.interface,
            };
        }
    }
    return uiSchema;
}
function getUiBehavior(component, viewModel) {
    var _a, _b;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var uiBehavior = {};
    if (component.uiBehavior) {
        (_d = (0, Utils_1.getKeys)((_c = component.uiBehavior) !== null && _c !== void 0 ? _c : {})) === null || _d === void 0 ? void 0 : _d.forEach(function (key) {
            var _a, _b;
            switch (key) {
                case "readonly":
                    uiBehavior["ui:readonly"] = (_a = component.uiBehavior) === null || _a === void 0 ? void 0 : _a[key];
                    break;
                default:
                    uiBehavior[key] = (_b = component.uiBehavior) === null || _b === void 0 ? void 0 : _b[key];
                    break;
            }
        });
    }
    if ((0, autoModuleViewHelpers_1.isUrl)(component)) {
        uiBehavior["ui:widget"] = "url";
    }
    else if ((0, autoModuleViewHelpers_1.isImage)(component)) {
        uiBehavior["ui:widget"] = "image";
    }
    var overriddenBehavior = {};
    if (viewModel) {
        var overriddenValue = (_f = (_e = viewModel.getDerivedFunction).getUiBehavior) === null || _f === void 0 ? void 0 : _f.call(_e, component.name);
        if (overriddenValue != undefined) {
            overriddenBehavior = __assign(__assign({}, overriddenBehavior), overriddenValue);
            if (((_g = (0, Utils_1.getKeys)(overriddenBehavior !== null && overriddenBehavior !== void 0 ? overriddenBehavior : {})) === null || _g === void 0 ? void 0 : _g.indexOf("readonly")) != -1) {
                overriddenBehavior["ui:readonly"] = overriddenBehavior["readonly"];
                delete overriddenBehavior["readonly"];
            }
        }
        var isEnabled = (_k = (_j = (_h = viewModel.getDerivedFunction).isEnabled) === null || _j === void 0 ? void 0 : _j.call(_h, component.name)) !== null && _k !== void 0 ? _k : (0, autoModuleViewHelpers_1.isModeActive)("isEnabled", component, viewModel.viewModel.getComponent);
        if (isEnabled != undefined) {
            overriddenBehavior = __assign(__assign({}, overriddenBehavior), (_a = {}, _a["ui:readonly"] = !isEnabled, _a));
        }
        var isVisible = (_m = (_l = viewModel.getDerivedFunction).isVisible) === null || _m === void 0 ? void 0 : _m.call(_l, component.name);
        if (isVisible != undefined) {
            if (!isVisible) {
                overriddenBehavior = __assign(__assign({}, overriddenBehavior), (_b = {}, _b["ui:widget"] = "hidden", _b));
            }
        }
    }
    uiBehavior = __assign(__assign({}, uiBehavior), overriddenBehavior);
    return uiBehavior;
}
//# sourceMappingURL=uiSchema.js.map